export const shadows = {
  base: "0px 4px 15px var(--chakra-colors-shadowColor)",
};
